import cn from 'classnames'
import { useSnapshot } from 'valtio'
import { type ReactElement } from 'react'
import { proxyGlobalAuth } from '../../../proxies/proxyGlobalAuth'

interface HamburgerProps {
  additionalClasses?: string
  onClick: () => void
}
export function Hamburger ({ additionalClasses, onClick }: HamburgerProps): ReactElement {
  const { siteTheme: { topNavBarHamburgerButton } } = useSnapshot(proxyGlobalAuth)

  const COMMON_CLASSES = `${topNavBarHamburgerButton.classes} h-1 rounded`
  return (
    <button className={cn('flex justify-center items-center w-10 px-8', additionalClasses)} style={{ height: '10vh' }} onClick={onClick}>
      <div className="flex flex-col">
        <div className={cn(COMMON_CLASSES, 'w-6 mb-1')} />
        <div className={cn(COMMON_CLASSES, 'w-6 mb-1')} />
        <div className={cn(COMMON_CLASSES, 'w-3')} />
      </div>
    </button>
  )
}
